/* eslint-disable max-len */
import { toFixed } from 'utils/normalizers';
import { message } from 'antd';

export const tiposDocumentosExentos = [
  8, // Sucesión o adjudicación testamentaria
  9, // Adjudicación intestamentaria
  10, // Cláusula de beneficiario
  11, // Cláusula testamentaria
];

const calculateValorBase = (padron, values = {}, tramites = []) => {
  let { aplica_beneficio_ley } = values;
  const { valor_catastral_calculado: avaluoId } = values;
  const aplica_avaluo = values.aplica_avaluo ?? padron?.aplica_avaluo;
  const uso = values.uso_de_predio_id ?? padron?.uso_de_predio_id
    ?? values.uso_de_predio ?? padron?.uso_de_predio;
  const tipoDoc = values.tipo_de_documento_traslado_id ?? padron?.tipo_de_documento_traslado_id
    ?? values.tipo_de_documento_traslado ?? padron?.tipo_de_documento_traslado;
  const tipoAvaluo = values.tipo_de_avaluo_id ?? padron?.tipo_de_avaluo_id ?? values.tipo_de_avaluo ?? padron?.tipo_de_avaluo;
  const omitir_valores_referenciados = values.omitir_valores_referenciados ?? padron?.omitir_valores_referenciados;
  const bimestre_referido_traslado = values.bimestre_referido_traslado ?? padron?.bimestre_referido_traslado;
  const anio_referido_traslado = values.anio_referido_traslado ?? padron?.anio_referido_traslado;
  const porcentaje_traslado = toFixed(values.porcentaje_traslado ?? padron?.porcentaje_traslado, 2);
  const valor_operacion_traslado = toFixed(values.valor_operacion_traslado ?? padron?.valor_operacion_traslado, 3);
  const valor_catastral = toFixed(values.valor_catastral ?? padron?.valor_catastral, 3);
  const avaluo = aplica_avaluo && tramites.find((t) => t.id === avaluoId)?.json;
  let valor_base_traslado = avaluo?.valor_catastral ?? valor_catastral;
  if (avaluo) {
    const valorReferido = !omitir_valores_referenciados && avaluo.valores_referidos
      ?.find((vr) => vr.anio_valor_referido === anio_referido_traslado
        && vr.bim_valor_referido === bimestre_referido_traslado);
    if (valorReferido) {
      valorReferido.valor_referido = toFixed(valorReferido.valor_referido, 2);
      valorReferido.valor_terreno = toFixed(valorReferido.valor_terreno, 2);
      valorReferido.valor_construccion = toFixed(valorReferido.valor_construccion, 2);
    }
    if (tipoAvaluo === 10) {
      valor_base_traslado = valorReferido?.valor_terreno ?? avaluo.valor_del_terreno;
    } else if (tipoAvaluo === 11) {
      valor_base_traslado = valorReferido?.valor_construccion ?? avaluo.valor_de_la_construccion;
    } else if (!tipoAvaluo) {
      valor_base_traslado = valorReferido?.valor_referido ?? avaluo.valor_catastral;
    }
  }
  valor_base_traslado *= (porcentaje_traslado / 100);
  if (uso !== 17 && valor_operacion_traslado > valor_base_traslado) {
    valor_base_traslado = valor_operacion_traslado;
  }

  valor_base_traslado = toFixed(valor_base_traslado, 3);
  const output = { valor_base_traslado };
  if (!tiposDocumentosExentos.includes(tipoDoc) && values.aplica_beneficio_ley) {
    message.info('Ley Bis 117 no es aplicable');
    aplica_beneficio_ley = false;
    output.aplica_beneficio_ley = aplica_beneficio_ley;
  }
  if (aplica_beneficio_ley) {
    const valorExento = padron?.participes.length * 1500000;
    valor_base_traslado = valorExento > valor_base_traslado
      ? 0 : valor_base_traslado - valorExento;
  }
  return output;
};

export default calculateValorBase;
